// extracted by mini-css-extract-plugin
export default {"root":"ErrorCard__root__uu1IU"};